import { logger } from 'utils/logger';
import { BucketTransition, PressureContext, TickSnapshot } from 'utils/webrtc/stats/types';

const BROADCASTER_CADENCE = 5; // ≈10 s at 0.5 Hz — one emission per ~2 hysteresis windows
const LISTENER_CADENCE = 15; // ≈30 s at 0.5 Hz

const remote = () => logger.remote({ capture: 'webrtc-scores', tier: 0, nonProd: true });

export const logTick = (snapshot: TickSnapshot, isBroadcaster: boolean): void => {
  const cadence = isBroadcaster ? BROADCASTER_CADENCE : LISTENER_CADENCE;
  if (snapshot.tickNumber % cadence !== 0) {
    return;
  }
  remote().info('webrtc-scores:tick', { isBroadcaster, ...snapshot });
};

export const logBucketTransition = (transition: BucketTransition): void => {
  remote().info('webrtc-scores:bucket', transition);
};

/** Emitted once per PC generation; a PC_n pcId confirms the wrapper tagged it. */
export const logWrappedPc = (pc: { pcKey: string; pcId: string }): void => {
  remote().info('webrtc-scores:pc-wrapped', pc);
};

export const logPressure = (durationMs: number, ctx: PressureContext): void => {
  remote().warn('webrtc-scores:pressure', { durationMs, ...ctx });
};
